import { useState } from "react";
import PropTypes from "prop-types";
import "components/ui/Faq/FaqQuestion.scss";
import HTMLContainer from "components/ui/HTML/HTMLContainer";

const FaqQuestion = ({ question, answer }) => {
  const [showResults, setShowResults] = useState(false)
  const onClick = () => setShowResults(prevCheck => !prevCheck)
  const showAnswer = showResults ? 'faq-item__answer--show' : ''

  return (
    <div className={ 'faq-item' }>
      <div className={ 'faq-item__top' } onClick={ onClick }>
        <div className={ 'faq-item__title' }>
          { question }
        </div>
        <div>
          <div className={ `faq-item__icon ${ showResults ? 'faq-item__icon--open' : '' }` }></div>
        </div>
      </div>
      <HTMLContainer className={ `faq-item__answer ${ showAnswer } ` } value={ answer }/>
    </div>
  )
}

FaqQuestion.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
}

export default FaqQuestion;
